import Run from '../model/Run';
import Room from '../model/Room';
import Companion from '../model/Companion';
import Fight from '../model/Fight';
import Shop from '../model/Shop';
import Fountain from '../model/Fountain';
import Treasure from '../model/Treasure';
import Celestial from '../model/Celestial';
import Collectable from '../model/Collectable';
import Map from '../model/Map';
import Enemy from '../model/Enemy';
import Card from '../model/Card';
import Status from '../model/Status';
import Library from '../utility/Library';

const UNLOGGED_TYPES = [
  "gamestate",
  "setplan"
]

let translateData = obj => {

  if (!obj)
    return obj;
  if (typeof obj !== "object")
    return obj;
  if (obj.id)
    return obj.id;
  return "object";
}

let reducer = (state = 0, n) => {

  switch (n.type) {
  case "gamestate": {
    state = Run.build(n.data[0]);
    if (n.data[1])
      state.log = n.data[1].slice();
    break;
  }
  case "gameover": {
    state.over = true;
    break;
  }
  case "victory": {
    state.win = true;
    break;
  }
  case "continue": {
    delete state.over;
    if (state.room.fight) {
      state.room.fight.enemies = [];
      state.room.fight.slots = [];
    }
    break;
  }
  case "storyevent": {
    delete state.win;
    state.storyEvent = true;
    state.champion.gold = 0;
    state.removes = 0;
    state.background = n.data[1];
    state.audio = n.data[2];
    state.memory = n.data[3];
    break;
  }
  case "newfloor": {
    state.act = n.data[0].act;
    state.map = Map.build(state, n.data[0].map.serialize());
    if (!state.storyEvent) {
      if (state.floor !== state.maxFloor)
        state.entropy = 0;
    }
    //state.map.grid = n.data[0].map.grid.map(row => [...row]);
    break;
  }
  case "divein": {
    state.floor++;
    state.time = 17;
    break;
  }
  case "newroom": {
    //new Room(state, n.data[0].model);
    break;
  }
  case "campfire": {
    state.campfireChoices = n.data[1];
    break;
  }
  case "roomcleanup": {
    delete state.room.fight;
    delete state.room.fountain;
    delete state.room.treasure;
    delete state.room.shop;
    break;
  }
  case "roomcollectable": {
    state.room.collectables.push(new Collectable(state, n.data[1], n.data[2]));
    break;
  }
  case "roomchangecollectable": {
    state.room.collectables[n.data[1]].value = n.data[2];
    break;
  }
  case "roomcollect": {
    state.room.collectables[n.data[1]] = null;
    break;
  }
  case "insight": {
    state.insight += n.data[1];
    break;
  }
  case "paws": {
    state.paws += n.data[1];
    break;
  }
  case "keys": {
    state.keys += n.data[1];
    break;
  }
  case "removes": {
    state.removes += n.data[1];
    break;
  }
  case "newfight": {
    let fight = new Fight(state);
    state.room.fight = fight;
    break;
  }
  case "startfight": {
    state.room.fight.slots = n.data[0].slots.map(slot => ({
      spawn: slot.spawn,
      scale: slot.scale,
      enemy: slot.enemy ? state.room.fight.find(slot.enemy.id) : undefined
    }));
    break;
  }
  case "newshop": {
    let shop = new Shop(state, state.room.model.model.script);
    state.room.shop = shop;
    break;
  }
  case "slotmachine": {
    state.room.shop.slotMachine = [ "coin", "coin", "coin" ];
    break;
  }
  case "runslots": {
    state.room.shop.slotMachine = n.data[1];
    break;
  }
  case "setchoices": {
    state.room.choiceText = n.data[1];
    state.room.choices = n.data[2];
    break;
  }
  case "addentity": {
    state.room.entities.push(Object.assign({}, n.data[1]));
    break;
  }
  case "clearroom": {
    delete state.room.shop;
    delete state.room.fight;
    delete state.room.fountain;
    delete state.room.treasure;
    state.room.entities = [];
    break;
  }
  case "newfountain": {
    let fountain = new Fountain(state);
    state.room.fountain = fountain;
    break;
  }
  case "newtreasure": {
    let treasure = new Treasure(state, n.data[2]);
    state.room.treasure = treasure;
    break;
  }
  case "newcelestial": {
    let celestial = new Celestial(state, n.data[2], false);
    celestial.remainingExp = n.data[0].remainingExp;
    state.room.celestial = celestial;
    break;
  }
  case "previewcelestial": {
    state.nextCelestialKey = n.data[1];
    break;
  }
  case "usefountain": {
    let fountain = state.room.fountain;
    fountain.active = false;
    break;
  }
  case "celestialactive": {
    let celestial = state.room.celestial;
    celestial.active = n.data[1];
    break;
  }
  case "celestialupgrade": {
    let celestial = state.room.celestial;
    celestial.remainingExp = n.data[0].remainingExp;
    celestial.offeringSteps = n.data[0].offeringSteps;
    celestial.surrendered = n.data[0].surrendered;
    break;
  }
  case "generatecelestialrelic": {
    let celestial = state.room.celestial;
    state.room.celestial.collectables.push(new Collectable(state, n.data[1].type, n.data[1].value));
    break;
  }
  case "takecelestialrelic": {
    let celestial = state.room.celestial;
    celestial.collectables = [];
    break;
  }
  case "generatetreasure": {
    let treasure = state.room.treasure;
    state.room.treasure.collectables.push(new Collectable(state, n.data[1].type, n.data[1].value));
    break;
  }
  case "taketreasure": {
    let treasure = state.room.treasure;
    treasure.collectables.splice(n.data[1], 1)
    break;
  }
  case "fillshop": {
    let shop = state.room.shop;
    shop.articles = n.data[1].slice();
    break;
  }
  case "shopchangearticle": {
    let shop = state.room.shop;
    shop.articles[n.data[1]] = Object.assign({}, n.data[2]);
    break;
  }
  case "shopbuy": {
    let shop = state.room.shop;
    if (!shop)
      break;
    shop.articles = n.data[0].articles.map(article => Object.assign({}, article));
    if (n.data[0].single)
      shop.single = n.data[0].single;
    else
      delete shop.single;
    break;
  }
  case "winfight": {
    state.room.fight.done = true;
    break;
  }
  case "droppingpotion": {
    state.droppingPotion = true;
    break;
  }
  case "droppingrelic": {
    state.droppingRelic = true;
    break;
  }
  case "curse": {
    state.champion.curses.push(Library.getCurse(n.data[1]));
    break;
  }
  case "curecurse": {
    state.champion.curses = state.champion.curses.filter(curse => curse.key !== n.data[1]);
    break;
  }
  case "changetime": {
    state.time += n.data[1];
    break;
  }
  case "gainmaxhp": {
    state.champion.gainMaxHp(n.data[1], n.data[2]);
    break;
  }
  case "losemaxhp": {
    state.champion.loseMaxHp(n.data[1], n.data[2]);
    break;
  }
  case "gainexp": {
    state.champion.exp += n.data[1];
    break;
  }
  case "gainoverflowexp": {
    state.champion.overflowExp = (state.champion.overflowExp || 0) + n.data[1];
    break;
  }
  case "loseexp": {
    state.champion.exp -= n.data[1];
    break;
  }
  case "loseoverflowexp": {
    state.champion.overflowExp = Math.max(0, (state.champion.overflowExp || 0) - n.data[1]);
    break;
  }
  case "gaingold": {
    state.champion.gold += n.data[1];
    break;
  }
  case "losegold": {
    state.champion.gold -= n.data[1];
    break;
  }
  case "gaincorruption": {
    state.champion.corruption += n.data[1];
    break;
  }
  case "losecorruption": {
    state.champion.corruption -= n.data[1];
    break;
  }
  case "gainarousal": {
    state.champion.arousal += n.data[1];
    break;
  }
  case "losearousal": {
    state.champion.arousal -= n.data[1];
    break;
  }
  case "relic": {
    state.champion.relics.push(n.data[1]);
    break;
  }
  case "loserelic": {
    state.champion.relics = state.champion.relics.filter(r => r.key !== n.data[1]);
    break;
  }
  case "potion": {
    state.champion.potions.push(n.data[1]);
    break;
  }
  case "usepotion": {
    const repeatPotions = state.champion.potions.filter(potion => potion.key === "repeat-potion");
    if (state.champion.potions[n.data[1]].next)
      state.champion.potions[n.data[1]] = Library.getPotion(state.champion.potions[n.data[1]].next);
    else
      state.champion.potions.splice(n.data[1], 1);
    repeatPotions.forEach(potion => {
      const repeatIndex = state.champion.potions.indexOf(potion);
      if (repeatIndex >= 0)
        state.champion.potions[repeatIndex] = Object.assign({}, n.data[2]);
    });
    if (state.champion.potions.length <= state.champion.potionSlots)
      delete state.droppingPotion;
    break;
  }
  case "droppotion": {
    state.champion.potions.splice(n.data[1], 1);
    if (state.champion.potions.length <= state.champion.potionSlots)
      delete state.droppingPotion;
    break;
  }
  case "droprelic": {
    state.champion.relics.splice(n.data[1], 1);
    delete state.droppingRelic;
    break;
  }
  case "levelup": {
    state.champion.exp -= state.champion.thresholdForLevel(state.champion.level);
    state.champion.level++;
    if (state.champion.level === state.champion.maxLevel) {
      state.champion.overflowExp = (state.champion.overflowExp || 0) + Math.max(0, state.champion.exp);
      state.champion.exp = 0;
    }
    state.champion.levelstep = 0;
    //state.levelingUp = true;
    //state.options = n.data[2];
    //delete state.reroll;
    break;
  }
  case "leveldown": {
    state.champion.level--;
    state.champion.exp += state.champion.thresholdForLevel(state.champion.level);
    state.champion.levelstep = 10;
    break;
  }
  case "levelstepup":
  case "levelstepdown": {
    state.champion.levelstep = n.data[1];
  }
  case "reroll": {
    delete state.reroll;
    state.options = n.data[1];
    break;
  }
  case "choosecampfire": {
    delete state.campfireChoices;
    break;
  }
  case "startrun": {
    //state.room = state.map.start;
    break;
  }
  case "enterroom": {
    let room = new Room(state, n.data[0]);
    state.rooms.push(room);
    if (room.type !== "start")
      state.deck.forEach(c => delete c.new);
    if (state.time > 0)
      state.time--;
    break;
  }
  case "pathchoices": {
    state.pathChoices = n.data[1];
    state.map.shift();
    break;
  }
  case "choosepath": {
    delete state.pathChoices;
    break;
  }
  case "maproomstoshops": {
    const layer = state.map.sections[n.data[1]];
    n.data[2].forEach(change => {
      if (layer?.[change.index])
        Object.assign(layer[change.index], change.model);
    });
    break;
  }
  case "dropcardchoice": {
    state.droppingCard = n.data[1] ? "free" : true;
    break;
  }
  case "dropcard": {
    /*if (n.data[1] >= 0 && state.droppingCard !== "free")
      state.removes--;*/
    delete state.droppingCard;
    delete state.levelingUp;
    break;
  }
  case "duplicatecardchoice": {
    state.duplicatingCard = true;
    break;
  }
  case "duplicatecard": {
    delete state.duplicatingCard;
    break;
  }
  case "skipcardchoice": {
    /*if (state.options.length > 1 && !state.champion.getPassive("cardremovalskip"))
      state.removes--;*/
    delete state.options;
    delete state.choosingCard;
    delete state.droppingCard;
    delete state.levelingUp;
    delete state.reroll;
    delete state.bundle;
    break;
  }
  case "mindecksize": {
    state.minDeckSize = Math.max(0, state.minDeckSize + n.data[1]);
    break;
  }
  case "newcard": {
    new Card(state.room.fight, n.data[2], n.data[0].id.no);
    break;
  }
  case "newenemy": {
    let enemy = new Enemy(state.room.fight, n.data[2], n.data[3]);
    // Use health captured when the notification was emitted. A summon may be
    // hit again before this queued notification reaches the view reducer; using
    // the live model object here would apply that later damage twice.
    enemy.hp = n.data[4] === undefined ? n.data[0].hp : n.data[4];
    enemy.maxhp = n.data[5] === undefined ? n.data[0].maxhp : n.data[5];
    state.room.fight.enemies.push(enemy);
    if ((!state.room.fight.slots || state.room.fight.slots.length === 0) && n.data[1].slots)
      state.room.fight.slots = n.data[1].slots.map(slot => ({
        spawn: slot.spawn,
        scale: slot.scale,
        enemy: undefined
      }));
    if (n.data[3] !== undefined) {
      let sourceSlot = n.data[1].slots[n.data[3]];
      state.room.fight.slots[n.data[3]] = Object.assign({}, sourceSlot, state.room.fight.slots[n.data[3]], { enemy });
    }
    break;
  }
  case "enemydie": {
    let enemy = state.room.fight.find(n.data[0].id);
    if (enemy)
      state.room.fight.removeEnemy(enemy);
    break;
  }
  case "minionsdie": {
    n.data[0].forEach(src => {
      let enemy = state.room.fight.find(src.id);
      if (enemy)
        state.room.fight.removeEnemy(enemy);
    });
    break;
  }
  case "intent": {
    let enemy = state.room.fight.find(n.data[0].id);
    enemy.nointent = n.data[1];
    break;
  }
  case "newcompanion": {
    state.companion = new Companion(state, n.data[1]);
    break;
  }
  case "companionintent": {
    state.room.fight.companion.nointent = n.data[1];
    break;
  }
  case "spendenergy": {
    state.companion.spendEnergy(n.data[1]);
    break;
  }
  case "skill.before": {
    if (n.data[1])
      state.room.fight.player.skillCooldown = (state.room.fight.player.skillCooldown || 0) + 1;
    break;
  }
  case "lockskill": {
    state.room.fight.player.skilllock = 2;
    break;
  }
  case "dissipatestatus": {
    let status = state.room.fight.find(n.data[0].id);
    if (status)
      status.dissipate();
    break;
  }
  case "changemana": {
    let card = state.room.fight.find(n.data[0].id);
    card.changeMana(n.data[1]);
    break;
  }
  case "manashift": {
    let card = state.room.fight.find(n.data[0].id);
    card.tempShiftMana(n.data[1]);
    break;
  }
  case "movecard": {
    let card = state.room.fight.find(n.data[0].id);
    let loc = state.room.fight.find(n.data[2].type);
    card.goto(loc);
    break;
  }
  case "addproperty": {
    let card = state.room.fight.find(n.data[0].id);
    card.addProperty(n.data[1]);
    break;
  }
  case "removeproperty": {
    let card = state.room.fight.find(n.data[0].id);
    card.removeProperty(n.data[1]);
    break;
  }
  case "statvalue": {
    let card = state.room.fight.find(n.data[0].id);
    card.statValues[n.data[1]] = n.data[2];
    break;
  }
  case "setpvariable": {
    let card = state.room.fight.find(n.data[0].id);
    card.permanentVariables[n.data[1]] = n.data[2];
    break;
  }
  case "clearpvariable": {
    let card = state.room.fight.find(n.data[0].id);
    delete card.permanentVariables[n.data[1]];
    break;
  }
  case "setfvariable": {
    state.room.fight.variables[n.data[1]] = n.data[2];
    break;
  }
  case "lifegain": {
    let entity = state.room?.fight ? state.room.fight.find(n.data[0].id) : state.champion;
    entity.hp += n.data[1];
    break;
  }
  case "blockgain": {
    let entity = state.room.fight.find(n.data[0].id);
    entity.block = (entity.block || 0) + n.data[1];
    break;
  }
  case "lifeloss": {
    let entity = state.room.fight ? state.room.fight.find(n.data[0].id) : state.champion;
    entity.hp -= n.data[2];
    entity.hp = Math.max(0, entity.hp)
    break;
  }
  case "blockloss": {
    let entity = state.room.fight.find(n.data[0].id);
    entity.block -= n.data[2];
    break;
  }
  case "entitystance": {
    let entity = state.room.fight.find(n.data[0].id);
    entity.nostance = n.data[1] < 0 ? undefined : n.data[1];
    entity.nointent = null;
    entity.setupPatterns();
    break;
  }
  case "applystatus": {
    let entity = state.room.fight.find(n.data[0].id);
    if (!entity)
      break;
    let existing = entity.statuses.filter(status => status.model.key === n.data[1]);
    if (existing.length > 0)
      existing[0].add(n.data[2], true);
    else
      entity.statuses.push(new Status(entity.master, n.data[1], entity, n.data[2], true));
    break;
  }
  case "addmana": {
    state.room.fight.addMana(n.data[1]);
    break;
  }
  case "paymana": {
    state.room.fight.pay(n.data[1], n.data[2], n.data[3]);
    break;
  }
  case "playerturn": {
    state.room.fight.turncount++;
    state.room.fight.enginesPlayed = 0;
    state.room.fight.mana = (state.room.fight.player.hasStatus("wake-up") || state.room.fight.player.hasStatus("life-loop") ? state.room.fight.mana : (state.room.fight.player.hasStatus("natures-gift") || state.room.fight.player.hasStatus("mana-loop") ? Math.min(state.room.fight.mana, state.room.fight.player.getStatusValue("natures-gift") + state.room.fight.player.getStatusValue("mana-loop")) : 0)) + state.room.fight.turnmana;
    state.room.fight.mana = Math.min(state.room.fight.mana, 100);
    state.room.fight.player.update();
    break;
  }
  case "endplayerturn": {
    state.room.fight.player.endturnUpdate();
    state.room.fight.hand.cards.forEach(card => {
      if (card.manashift)
        delete card.manashift;
    });
    break;
  }
  case "enemyturn": {
    state.room.fight.enemies.forEach(enemy => enemy.update());
    break;
  }
  case "endenemyturn": {
    state.room.fight.enemies.forEach(enemy => enemy.endturnUpdate());
    break;
  }
  case "fightloot": {
    state.room.fight.addLoot(Object.assign({}, n.data[1]));
    break;
  }
  case "fightreward": {
    state.room.fight.rewarding = true;
    break;
  }
  case "collectloot": {
    state.room.fight.loot.splice(n.data[1], 1)
    break;
  }
  case "newcardchoice": {
    state.choosingCard = true;
    state.options = n.data[1];
    state.reroll = n.data[2];
    break;
  }
  case "newcardbundle": {
    state.choosingCard = true;
    state.options = n.data[1];
    state.bundle = true;
    break;
  }
  case "collectcard": {
    delete state.choosingCard;
    break;
  }
  case "handchoice": {
    state.room.fight.choosingHand = true;
    break;
  }
  case "chosehand": {
    delete state.room.fight.choosingHand;
    break;
  }
  case "addcard": {
    let model = n.data[1];
    state.deck.push({card: model, new: !model.starter, status: "enabled"});
    if (state.entropy)
      state.entropy--;
    break;
  }
  case "enablecard": {
    state.switchEnableCard(n.data[1]);
    break;
  }
  case "removecard": {
    state.removeCard(n.data[1]);
    break;
  }
  case "timedown": {
    state.time--;
    break;
  }
  default: break;
  }


  if (typeof state === "object" && !UNLOGGED_TYPES.includes(n.type)) {
    state.log = state.log || [];
    state.log.push({ type: n.type, data: n.data.map(d => translateData(d)) });
  }

  return state;
}

export default reducer;
